import React, { useState } from 'react'
import { Navigate, useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'
import styled from 'styled-components'
import api from '../../../api'
import Responsive from '../../../assets/config/Responsive'
// import InvisibleEyeIcon from "../../assets/icons/JSX/InvisibleEyeIcon";
import Colors from '../../../assets/styles/Colors'
import { Container } from '../../../assets/styles/GlobalStyle'
// import FacebookSignin from "../../components/FacebookSignin";
// import GoogleSignin from "../../components/GoogleSignin";
import { Form, Formik, useFormik } from 'formik'
import * as Yup from 'yup'
import Input from '../../../components/Input'
import Loader from '../../../components/Loader'
import ScreenHeader from '../../../components/ScreenHeader'
import { UserRole } from '../../../domain/types'
import { useAppSelector } from '../../../store'
import { useTranslation } from 'react-i18next'
import { Helmet } from 'react-helmet-async'
//
//
// If there is a token, then log in automatically
const AutoLogin = ({ children }: any) => {
  const auth = useAppSelector((data) => data.auth)
  if (auth.userloading) {
    return <Loader />
  }
  return auth.token && auth.user && auth.user.userType === UserRole['User'] ? (
    <Navigate replace to={'/my-policies'} state={{ from: 'routerProps.location' }} />
  ) : (
    children
  )
}

const Login = () => {
  //
  const [email, setEmail] = useState<string>('')
  const [password, setPassword] = useState<string>('')
  //
  // login mutation
  const [login, { isLoading }] = api.useLoginMutation()
  //
  const { t } = useTranslation()
  //
  // custom navigate
  const navigate = useNavigate()
  //
  //
  const Login = async () => {
    try {
      await login({ email, password }).unwrap()
      navigate(`/my-policies`)
    } catch (error: any) {
      if (error?.data?.errors?.constructor === Array) {
        const firstError = error.data.errors[0]
        const errorMessage = firstError.message
        toast.error(errorMessage)
      } else {
        toast.error(`${t('anErrorOccurred')}`)
      }
    }
  }
  // keyboard login
  const EnterTrigger = (e: { charCode: any; keyCode: number }) => {
    if (e.charCode === 13) {
      Login()
    }
  }
  //
  //
  // yup validations schema
  const PersonalInfoValidationSchema = Yup.object({
    email: Yup.string()
      .matches(/^\S*$/, 'გთხოვთ წაშალეთ გამოტოვება')
      .email('გთხოვთ შეიყვანოთ ვალიდური მეილი')
      .required('სავალდებულო'),
    password: Yup.string().required('სავალდებულო'),
  })
  // initial values
  const initialValues = {
    email: email || '',
    password: password || '',
  }
  // formi state
  const formik = useFormik({
    initialValues: initialValues,
    validationSchema: PersonalInfoValidationSchema,
    enableReinitialize: true,
    validateOnMount: true,
    validateOnChange: true,
    validateOnBlur: true,
    onSubmit: (values, { setSubmitting }) => {
      setSubmitting(false)
    },
  })
  //
  const MainLoading = isLoading
  //

  return MainLoading ? (
    <Loader />
  ) : (
    <Formik
      initialValues={initialValues}
      validationSchema={PersonalInfoValidationSchema}
      enableReinitialize={true}
      validateOnMount={true}
      validateOnChange={true}
      validateOnBlur={true}
      onSubmit={(values, { setSubmitting }) => {
        setSubmitting(false)
      }}
    >
      {({ handleSubmit, handleBlur, setFieldValue, touched, errors, setTouched }) => (
        <Form onSubmit={handleSubmit}>
          <AutoLogin>
            <Helmet>
              <title>{t('loginHelmetTitle')}</title>
              <meta name="description" content={`${t('loginHelmetTitle')}`} />
              <link rel="canonical" href={window.location.href} />
            </Helmet>
            <ScreenHeader text={t('homePage')} url="/" />
            <Container>
              <MainWrapper>
                <LargeTitle>{t('hi')}</LargeTitle>

                <Wrapper>
                  <CustomForm>
                    <Input
                      id="email"
                      label={t('email')}
                      type="text"
                      placeholder=""
                      value={email}
                      name="email"
                      onChange={(value) => [setEmail(value?.toLowerCase()), setFieldValue('email', value)]}
                      width={'fullWidth'}
                      error={(touched.email || email) && errors.email ? true : false}
                      errorText={errors.email}
                      onBlur={handleBlur}
                      onKeyPress={EnterTrigger}
                      style={{ marginBottom: '24px' }}
                    />

                    <Input
                      id="password"
                      label={t('password')}
                      type="password"
                      placeholder=""
                      value={password}
                      name="password"
                      onChange={(value) => [setPassword(value), setFieldValue('password', value)]}
                      width={'fullWidth'}
                      error={(touched.password || password) && errors.password ? true : false}
                      errorText={errors.password}
                      onBlur={handleBlur}
                      onKeyPress={EnterTrigger}
                      style={{ marginBottom: '24px' }}
                      icon={true}
                    />

                    <ForgetPasswordText onClick={() => navigate('/reset-password', { state: email })}>
                      {t('forgetPassword')}
                    </ForgetPasswordText>

                    <SigninBtn
                      onClick={() => {
                        setTouched({
                          email: true,
                          password: true,
                        })

                        formik.validateForm().then((errors) => {
                          if (Object.keys(errors).length === 0) {
                            Login()
                          }
                        })
                      }}
                      id="sign-in-btn"
                    >
                      {t('signIn')}
                    </SigninBtn>

                    {/* <Text>Or</Text>
            <GoogleSigninStyle/>
            <FacebookSigninStyle/> */}

                    <NotRegisteredText>
                      <div>{t('notRegisteredYet')}</div>
                      <SignUpText onClick={() => navigate('/auth/personal-info')}>{t('signUp')}</SignUpText>
                    </NotRegisteredText>
                  </CustomForm>
                </Wrapper>
              </MainWrapper>
            </Container>
          </AutoLogin>
        </Form>
      )}
    </Formik>
  )
}

const Wrapper = styled.div`
  background-color: ${Colors.white};
  padding: 48px 64px 56px 64px;
  max-width: 528px;
  margin: 0 auto 140px auto;

  /* responsive */
  ${Responsive.mobile} {
    padding: 32px 24px 40px 24px;
    margin-bottom: 100px;
  }
`
const CustomForm = styled.div`
  margin-bottom: 25px;
`
const MainWrapper = styled.div`
  /*  */
`
const LargeTitle = styled.h1`
  font-size: 36px;
  line-height: 40px;
  color: ${Colors.primaryBlack};
  text-align: center;
  margin-top: 56px;
  margin-bottom: 56px;
  text-transform: capitalize;

  /* responsive */
  ${Responsive.tablet} {
    font-size: 24px;
    line-height: 26px;
  }

  /* responsive */
  ${Responsive.mobile} {
    font-size: 18px;
    line-height: 20px;
    margin-bottom: 56px;
    margin-top: 56px;
  }
`
const SigninBtn = styled.button`
  width: 100%;
  height: 55px;
  margin: 0px;
  padding: 0px;
  outline: none;
  border-radius: 4px;
  border: none;
  background-color: #fe5f55;
  margin-top: 30px;
  font-size: 16px;
  color: ${Colors.white};
  ${Responsive.tablet} {
    width: 100%;
    height: 46px;
  }
  ${Responsive.mobile} {
    width: 100%;
    height: 48px;
    margin-top: 30px;
    margin-left: 0px !important;
  }
`
// const Text = styled.div`
//     text-align: center;
//     margin-top: 10px;
//     margin-bottom: 10px;
//     color: ${Colors.primaryGrey};
// `;
// const GoogleSigninStyle = styled(GoogleSignin)`
//     margin-bottom: 30px;
//     width: 100%;
// `;
// const FacebookSigninStyle = styled(FacebookSignin)`
//     width: 100%;
// `;
const ForgetPasswordText = styled.div`
  text-align: right;
  font-size: 18px;
  margin: 0;
  cursor: pointer;
  color: ${Colors.primaryBlack};
  ${Responsive.mobile} {
    font-size: 15px;
  }
`
const NotRegisteredText = styled.div`
  font-size: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  justify-content: space-between;
  margin-top: 30px;
  color: ${Colors.primaryGrey};
  /* font-family: 'roboto'; */
  ${Responsive.mobile} {
    font-size: 15px;
  }
`
const SignUpText = styled.div`
  cursor: pointer;
  text-decoration: underline;
  margin-left: 5px;
  color: ${Colors.Black};
`

export default Login
